module.exports = __webpack_public_path__ + "img/limeservice.png";